<app-form-input
[label]="''"
[name]="radioButtonCtrlName"
[value]="radioButtonValue"
[parentForm]="parentForm"
[disabled]="disabled"
[type]="'radio'"
[rule]="'pattern_29'"
[radios]="[
    {
        value: conceptionRealisation,
        label: step2.getconceptionrealisation
    },
    {
        value: execution,
        label: step2.getexecution
    }
]"
>
</app-form-input>

<!-- <app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="marcheTravaux?.conceptionRealisation" 
 
[label]="'conceptionRealisation'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_conceptionRealisation'">
</app-form-input> -->
